module.exports = __webpack_public_path__ + "static/media/check@2x.png?v=d2ee47b8";